export const err = (formik: any, column: string) => '' + formik.errors[column]
